import { CouponList, CouponCreate, CouponEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        CouponList,
        CouponCreate,
        CouponEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'coupon',
    icon: 'fa-tag',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/Coupon/index.ts